import React, { createContext, useContext } from 'react';

var ThemeContext = createContext(null);

var Provider = ThemeContext.Provider,
    Consumer = ThemeContext.Consumer;

var ThemeProvider = function ThemeProvider(_ref) {
  var theme = _ref.theme,
      children = _ref.children;
  return React.createElement(
    Provider,
    {
      value: theme
    },
    children
  );
};

// eslint-disable-next-line
ThemeProvider.displayName = 'ThemeProvider';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var withTheme = (function (WrappedComponent) {
  var WithTheme = function WithTheme(props) {
    return React.createElement(
      Consumer,
      null,
      function (providedTheme) {
        return React.createElement(WrappedComponent, _extends({
          theme: providedTheme
        }, props));
      }
    );
  };

  // eslint-disable-next-line
  WithTheme.displayName = 'WithTheme';

  return WithTheme;
});

var useTheme = function useTheme() {
  var theme = useContext(ThemeContext);

  return theme;
};

var withThemeHook = function withThemeHook(props) {
  return Object.assign({
    theme: useTheme()
  }, props);
};

export { ThemeProvider, useTheme, withTheme, withThemeHook };
